"use client";
import { motion } from "framer-motion";
import FAQItem from "@/components/FAQItem";
import { useTranslations } from "@/i18n/provider";

const FAQS = ({ page }: { page?: string }) => {
  const t = useTranslations();
  const faqs = [
    {
      question: t("partner.page.faqs.costQuestion"),
      answer: t("partner.page.faqs.costAnswer"),
    },
    {
      question: t("partner.page.faqs.verificationQuestion"),
      answer: t("partner.page.faqs.verificationAnswer"),
    },
    {
      question: t("partner.page.faqs.activitiesQuestion"),
      answer: t("partner.page.faqs.activitiesAnswer"),
    },
    {
      question: t("partner.page.faqs.paymentsQuestion"),
      answer: t("partner.page.faqs.paymentsAnswer"),
    },
  ];

  const creatorFaqs = [
    {
      question: t("creator.page.faqs.earnQuestion"),
      answer: t("creator.page.faqs.earnAnswer"),
    },
    {
      question: t("creator.page.faqs.activitiesQuestion"),
      answer: t("creator.page.faqs.activitiesAnswer"),
    },
    {
      question: t("creator.page.faqs.paymentsQuestion"),
      answer: t("creator.page.faqs.paymentsAnswer"),
    },
    {
      question: t("creator.page.faqs.payoutsQuestion"),
      answer: t("creator.page.faqs.payoutsAnswer"),
    },
  ];

  return (
    <section className="bg-[#EFFAF6] py-8">
      <div className="py-16">
        <div className="container px-4 max-w-4xl">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-center mb-12"
          >
            <h2 className="text-2xl md:text-4xl font-bold text-gray800 mb-4">
              {page === "creator"
                ? t("creator.page.faqTitle")
                : t("partner.page.faqTitle")}
            </h2>
            <p className="text-lg text-gray-600">
              {page === "creator"
                ? t("creator.page.faqText")
                : t("partner.page.faqText")}
            </p>
          </motion.div>

          <div className="mt-12">
            {(page === "creator" ? creatorFaqs : faqs).map((faq, index) => (
              <FAQItem
                key={index}
                question={faq.question}
                answer={faq.answer}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQS;
